<template>
  <div class="modal-overlay" v-if="visible && participant" @click.self="$emit('cancel')">
    <div class="modal-card pag-modal">
      <h2 class="modal-title">Registrar pagamento</h2>
      <p class="subtitle">{{ participant.name }}</p>

      <form @submit.prevent="handleSubmit" class="form">
        <div class="form-row">
          <div class="form-group form-valor">
            <label class="label" for="pag-valor">Valor (R$) *</label>
            <input
              id="pag-valor"
              class="input"
              type="text"
              inputmode="decimal"
              v-model="form.valor"
              placeholder="32,00"
              autocomplete="off"
              ref="valorInput"
            />
            <span class="error-msg" v-if="errors.valor">{{ errors.valor }}</span>
          </div>
          <div class="form-group form-data">
            <label class="label" for="pag-data">Data *</label>
            <input
              id="pag-data"
              class="input"
              type="date"
              v-model="form.data"
              autocomplete="off"
            />
            <span class="error-msg" v-if="errors.data">{{ errors.data }}</span>
          </div>
        </div>

        <div class="form-group">
          <label class="label" for="pag-obs">Observação</label>
          <input
            id="pag-obs"
            class="input"
            type="text"
            v-model="form.observacao"
            placeholder="Ex: parcela 1, dinheiro, etc."
            autocomplete="off"
            maxlength="300"
          />
        </div>

        <div v-if="participant.falta != null" class="hint">
          Falta atual: <strong>{{ formatBRL(participant.falta) }}</strong>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-secondary" @click="$emit('cancel')">Cancelar</button>
          <button type="submit" class="btn-primary" :disabled="submitting">
            <span v-if="!submitting">Registrar</span>
            <span v-else>Salvando...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { formatBRL } from '../lib/financeiro'

export default {
  name: 'PagamentoModal',
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null },
    submitting: { type: Boolean, default: false }
  },
  emits: ['save', 'cancel'],
  data() {
    return { form: this.emptyForm(), errors: {} }
  },
  watch: {
    visible(open) {
      if (!open) return
      this.form = this.emptyForm()
      this.errors = {}
      this.$nextTick(() => this.$refs.valorInput?.focus())
    }
  },
  methods: {
    formatBRL,
    emptyForm() {
      const hoje = new Date()
      const iso = hoje.toISOString().slice(0, 10)
      return { valor: '', data: iso, observacao: '' }
    },
    parseValor(raw) {
      if (raw === null || raw === undefined) return Number.NaN
      const s = String(raw).trim()
      if (!s) return Number.NaN
      const n = Number(s.replace(/[R$\s]/g, '').replace(',', '.'))
      if (!Number.isFinite(n)) return Number.NaN
      return Math.round(n * 100) / 100
    },
    validate() {
      const errors = {}
      const valor = this.parseValor(this.form.valor)
      if (Number.isNaN(valor)) errors.valor = 'Valor inválido'
      else if (valor <= 0) errors.valor = 'Valor deve ser maior que zero'
      if (!this.form.data) errors.data = 'Data é obrigatória'
      this.errors = errors
      return Object.keys(errors).length === 0
    },
    handleSubmit() {
      if (!this.validate()) return
      this.$emit('save', {
        valor: this.parseValor(this.form.valor),
        data: this.form.data,
        observacao: (this.form.observacao || '').trim() || null
      })
    }
  }
}
</script>

<style scoped>
.pag-modal { max-width: 460px; }
.subtitle {
  font-size: var(--text-sm); color: var(--color-text-muted);
  margin: -8px 0 var(--spacing-base);
}
.form { display: flex; flex-direction: column; gap: var(--spacing-base); }
.form-row { display: flex; gap: var(--spacing-md); }
.form-group { display: flex; flex-direction: column; flex: 1; }
.form-valor { flex: 1; }
.form-data { flex: 1; }
.hint {
  font-size: var(--text-sm); color: var(--color-text-secondary);
  background: var(--color-bg-hover);
  padding: 8px 12px; border-radius: var(--radius-md);
}
@media (max-width: 480px) {
  .form-row { flex-direction: column; }
}
</style>
